export default __webpack_public_path__ + "static/media/logo-canadalife.7959ae1d.png";